import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Button, IconButton, DialogActions } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { COLORES } from '../../config/colores'
import PrintIcon from '@material-ui/icons/Print'

function DialogView (props) {
  const {
    confirmCallback = null,
    cancelCallback,
    title,
    subtitle,
    content,
    showPrint = false
  } = props

  return (
    <div style={{ padding: '8px' }}>
      <IconButton
        onClick={cancelCallback}
        style={{ margin: '0', padding: '5px 0', float: 'right' }}
      >
        <CloseIcon style={{ color: COLORES.grey.dark }} />
      </IconButton>
      <Row>
        <Col md={12} style={{ textAlign: 'center', color: COLORES.grey.dark }}>
          {title ? <h3>{title}</h3> : <h3 style={{ padding: '10px' }}> </h3> }
          {subtitle && <h5>
            {subtitle}
          </h5>
          }
        </Col>
      </Row>

      <hr />

      { content && <div
        style={{ marginTop: '20px', paddingBotton: '20px' }}>
        {content}
      </div>
      }

      { confirmCallback || showPrint
        ? <DialogActions style={{ marginTop: '22px' }}>
          {confirmCallback
            ? <div style={{ display: 'flex', flexWrap: 'nonwrap', justifyContent: 'center', alignItems: 'center' }}>
              <Col md={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  onClick={confirmCallback}
                  type='button'
                  size='medium'
                  variant='contained'
                  color='primary'
                > Confirmar
                </Button>
              </Col>
            </div>
            : null
          }
          {showPrint &&
            <IconButton
              style={{ outline: 'none' }}
              onClick={() => window.print()}
            >
              <PrintIcon color='primary' fontSize='large' />
            </IconButton>
          }
        </DialogActions>

        : <></>
      }

    </div>
  )
}

export default DialogView
